import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";

import { RecordsUsersTable, UsersTable } from "./Tables";

import "react-toastify/dist/ReactToastify.css";

import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";

import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import Records from "../../utils/records";

import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";
import { isInDateRange } from "../../utils/DataUtils";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { FilterMatchMode } from "primereact/api";
import { dateFormat } from "../../utils/date";
import { toast } from "react-toastify";
import { setIn } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import PromiseWrapper from "../Utils/PromiseDialog";

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const Users = ({dataFarm}) => {
    const location = useLocation();
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const [_, dispatch] = useContext(FarmContext);
    const [arrUsersRecords, setArrUsersRecords] = useState([]);
    const canEdit = dispatch({ type: "get", path: "canEdit" });
    const info = dispatch({ type: "get", path: "users" });
    const [showValidation, setShowValidation] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [showValidation3M, setShowValidation3M] = useState(false);
    const [rangeDates, setRangeDates] = useState(null);
    const [invitations, setInvitations] = useState(null);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const today = new Date();
    const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6);
    const [firstExec, setFirstExec] = useState(true);
    const acceso_limitado = dispatch({ type: "get", path: "accesoLimitado" });
    const promiseWrapper = useRef(null);

    useEffect(() => {
        if (invitations === null) {
            const param = `/users/${farmId}/invitations`;
            const getInvitations = async () => {
                RestAPI.get("apiAdminDropControl", param)
                    .then(json => {
                        setInvitations(json??[]);
                    })
                    .catch(err => console.error(err));
            };
            getInvitations();
        }
    }, [invitations]);
    useEffect(() => {
        const blocked = dispatch({ type: "check", params: farmId });
        if (blocked) return;
        dispatch({ type: "update", path: "users", params: { isLoaded: false } });
        if (farmId !== null) {
            const param = `/users/${farmId}`;

            const getDatos = async () => {
                RestAPI.get("apiAdminDropControl", param)
                    .then(json => {
                        if (json && !json.users) json.users = [];
                        dispatch({ type: "update", path: "users", params: { isLoaded: true, data: json } });
                    })
                    .catch(err => console.error(err));
            };
            getDatos();
        }
    }, [farmId]);

    const usersInfo = info.data && info.data.users;

    useEffect(() => {
        if (firstExec) {
            if(!rangeDates){
                setRangeDates([lastWeek, today]);
            }
            if (usersInfo) {
                const lng = i18n.language;
                if (usersInfo.length && firstExec) {
                    setCalendarLoading(true);
                    const promise_result = Records(usersInfo, lastWeek, today, lng, farmId, null);
                    promise_result.then(arr => setArrUsersRecords(arr));
                    setFirstExec(false);
                }
            }
        }
        if (usersInfo && arrUsersRecords.length === usersInfo.length) setTimeout(() => { setCalendarLoading(false); }, 200);
    }, [i18n.language, rangeDates, farmId, usersInfo, arrUsersRecords]);

    const selfHelpImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usertable-1.png`];
    const selfHelpImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usertable-2.png`];

    const selfHelpImgDes1 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-1.png`];
    const selfHelpImgDes2 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-2.png`];
    const selfHelpImgDes3 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-3.png`];
    const selfHelpImgDes4 = import.meta.glob("../../img/autoayuda/*/autoayuda-usersRecords-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-usersRecords-4.png`];

    const selfHelpTabla = [
        {
            tab: 1, header: { text: t("selfHelp.instructions") }, params:
        [
            { id: 1, text: t("selfHelp.usersRecords.msg1"), image: selfHelpImgDes1 },
            { id: 2, text: t("selfHelp.usersRecords.msg2"), image: selfHelpImgDes2 },
            { id: 3, text: t("selfHelp.usersRecords.msg3"), image: selfHelpImgDes3 },
            { id: 4, text: t("selfHelp.usersRecords.msg4"), image: selfHelpImgDes4 },
        ]
        },
        {
            tab: 2, header: { text: t("selfHelp.definitionsHeader") }, definition: true, params:
        [
            { id: 1, defName: "DropControl: ", defText: t("selfHelp.definitions.dias_dc") },
            { id: 2, defName: "DropControl APP: ", defText: t("selfHelp.definitions.dias_dc_app") },
            { id: 2, defName: `${t("forms.riegosProgramados")}: `, defText: t("selfHelp.definitions.cant_riegos") },
            { id: 2, defName: `${t("forms.comentariosRealizados")}: `, defText: t("selfHelp.definitions.cant_comentarios") }
        ],
        }
    ];
    const heightTable = Array.isArray(invitations) &&
    (invitations?.length < 10 ? `${invitations?.length * 100}px` : "500px");
    return (
        <div className='row-container'>
            {(info.isLoaded === false || showLoading) && <LoadingDialog />}
            <div className='row'>
                <div className="col">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    <SelfHelp t={t} lng={i18n.language} userTable images={[selfHelpImg1, selfHelpImg2]} />
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("users.users")}</span></h5>
                                </div>
                                <div id="usersTableToolbar"
                                    className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                                />
                            </div>
                            <div className='linea-titulo' />
                            <UsersTable usersData={usersInfo} tipousuario={info.data && info.data.tipousuario} farmId={farmId}
                                canEdit={canEdit} t={t} i18n={i18n} dispatch={dispatch} acceso_limitado={acceso_limitado} invitations={invitations} setInvitations={setInvitations}
                            />
                        </div>
                    </div>
                    {
                        Array.isArray(invitations) && invitations.length>0?
                            <>
                                <PromiseWrapper
                                    ref={promiseWrapper}
                                    yesText={t("general.answerYes")} noText={t("general.answerNo")}
                                    headerText={t("general.confirm")} contentText={t("users.invitationDelConfirm")}
                                />
                                <div className="card">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col col-sm-2 col-md-3 col-lg-4' />
                                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                                <h5 className="card-title"><span>{t("invitationPage.cardTitle")}</span></h5>
                                            </div>
                                            <div id="usersTableToolbar"
                                                className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                                            />
                                        </div>
                                        <div className='linea-titulo' />
                                        <DataTablePrime
                                            t={t}
                                            header={invitations?.length>=5?"search":null}
                                            items={invitations}
                                            scrollHeight={heightTable}
                                            deletableRow
                                            deleteFunction = {async (event, rowData) =>{
                                                setShowLoading(true);
                                                if (!promiseWrapper.current) return;
                                                promiseWrapper.current.getPromiseAnswer().then((del) => {
                                                    if (!del){
                                                        setShowLoading(false);
                                                        return;
                                                    }
                                                    RestAPI.post("apiAdminDropControl", `/users/${rowData.campo_id}/deleteInvitation`, { body:{"uuid":rowData.id} })
                                                        .then(res => {
                                                            if(res.status==="success"){
                                                                toast.success(t("invitationPage.deleteInvitation"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                                const index = invitations.findIndex(e => e.id ===res?.deleted?.[0]?.id);
                                                                if(index >=0){
                                                                    const newInvitations = [...invitations];
                                                                    newInvitations.splice(index,1);
                                                                    setInvitations(newInvitations);
                                                                }
                                                                setShowLoading(false);
                                                            }else{
                                                                toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                                setShowLoading(false);
                                                            }
                                                        })
                                                        .catch(err => {
                                                            console.error(err);
                                                            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                        } );
                                                });
                                            }}
                                            filters={{
                                                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                                            }}
                                            size="small"
                                            extra_option={{
                                                "icon":
                                                <TooltipPrime id="re_invite_user" content={t("users.resendInvitation")} position="bottom">
                                                    <FontAwesomeIcon icon={faPaperPlane} size="lg" style={{color:"GrayText"}} />
                                                </TooltipPrime>,
                                                "function":async (event, rowData) => {
                                                    setShowLoading(true);
                                                    RestAPI.post("apiAdminDropControl", `/users/${rowData.campo_id}/resendInvitation`, { body:{"uuid":rowData.id, "locale":i18n.language} })
                                                        .then(res => {
                                                            if(res.status==="success"){
                                                                toast.success(t("invitationPage.inviteToast"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                                const index = invitations.findIndex(e => e.id ===res?.invitation?.id);
                                                                if(index >=0){
                                                                    const newInvitations = [...invitations];
                                                                    newInvitations[index] = res?.invitation;
                                                                    setInvitations(newInvitations);
                                                                }
                                                                setShowLoading(false);
                                                            }else{
                                                                toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                                setShowLoading(false);
                                                            }
                                                        })
                                                        .catch(err => {
                                                            console.error(err);
                                                            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                                                            setShowLoading(false);
                                                        } );
                                                }}}
                                            globalFilterFields={["email"]}
                                            fields={[
                                                {field:"id",header:"",hidden:true,  bodyStyle:{textAlign:"center"}},
                                                {field:"email",header:t("personal.email")},
                                                {field:"expiracion",header:t("invitationPage.fechaExp"), body:(e) => dateFormat(e.expiracion, t, i18n.language, dataFarm?.huso_horario, true)},
                                                {field:"fecha_envio_correo",header:t("invitationPage.fechaCorreo"), body:(e) => dateFormat(e.fecha_envio_correo, t, i18n.language, dataFarm?.huso_horario)},
                                                {tipousuario_id:"email",header:t("users.tipousuario"),body:(e) => e?.tipousuario_label?.[i18n?.language]??e?.tipousuario_label?.en??t("users.custom"),}
                                            ]}
                                        />
                                    </div>
                                </div>
                            </>
                            :null
                    }
                    <div className="card" id='cardUsersAccess' >
                        {calendarLoading && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpTabla &&
                    <SelfHelp t={t} lng={i18n.language} params={selfHelpTabla} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("forms.registros")}</span></h5>
                                </div>
                                <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center' />
                            </div>
                            <div className='linea-titulo' />
                            <div className='row'>
                                <div className="col-12 col-md-6 text-md-right mtem-05">
                                    <label className="boldie">{t("forms.rangoFechas")}</label>
                                </div>

                                <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                    <div>
                                        <CalendarPrime
                                            id="daterangepicker"
                                            t={t}
                                            maxDaysRange={90}
                                            setValue={setRangeDates}
                                            value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                            locale={i18n.language}
                                            selectionMode="range"
                                            presets
                                        />
                                    </div>
                                </div>
                                {showValidation &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgUserAccessValidation")}</span>
                  </div>}
                                {showValidation3M &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgValidacionRangoFechas3M")}</span>
                  </div>}
                            </div>

                            <div className="row">
                                <div className='col-12 mb-4 mt-4 text-center'>
                                    <ButtonPrime onClick={() => {
                                        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0] || null;
                                        const hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1] || null;
                                        if (desde && hasta) {
                                            if(isInDateRange(desde,hasta,91)){
                                                setShowValidation3M(true);
                                                setShowValidation(false);
                                            }else{
                                                setArrUsersRecords([]);
                                                !calendarLoading && setCalendarLoading(true);
                                                if (info && info.data && info.data.users) {
                                                    if (usersInfo.length) {
                                                        const promise_result = Records(usersInfo, desde, hasta, i18n.language, farmId, null);
                                                        promise_result.then(arr => setArrUsersRecords(arr));
                                                    }
                                                    setShowValidation3M(false);
                                                    setShowValidation(false);
                                                }
                                            }
                                        }  else {
                                            if (!rangeDates?.[1] || !rangeDates?.[0]) {
                                                setShowValidation(true);
                                                setShowValidation3M(false);
                                            }
                                        }
                                    }} label={t("forms.search")}
                                    />
                                </div>
                            </div>
                            <RecordsUsersTable usersData={arrUsersRecords} farmId={farmId} t={t} lng={i18n.language} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default withName(Users, "UsersFrag");
